export default __webpack_public_path__ + "static/media/witnesses-legal-team-defendant.d74b856e.jpg";